import type { FunctionComponent } from "react";

import classNames from "classnames";
import styled from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";

import { UpgradeLink } from "./UpgradeLink";

export const CountryFlagContainer = styled.div<{ width?: string; height?: string }>`
    display: flex;
    flex-shrink: 0;
    width: ${({ width }) => width || "1em"};
    height: ${({ height }) => height || "1em"};
    margin-right: 7px;
`;

type Props = { countryCode: number; text: string; className?: string };

export const CountryCellContent: FunctionComponent<Props> = ({ countryCode, text, className }) => {
    return (
        <>
            <CountryFlagContainer className={classNames(className, "countryIcon-container")}>
                <SWReactCountryIcons countryCode={countryCode} />
            </CountryFlagContainer>
            {countryCode === -1 ? (
                <UpgradeLink />
            ) : (
                <div
                    className="country-text"
                    title={text}
                >
                    {text}
                </div>
            )}
        </>
    );
};
